export default __webpack_public_path__ + "static/media/mlb-logo.a91cfad3.png";